import React, { useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { validation } from '../../utils/handleChangeHooks';
import { isNullOrEmpty } from '../../utils/util';
import { connect } from 'react-redux';

const TextAreaUI = (props) => {
    let inputRef;
    let propsUi = {};
    if (props) {
        Object.assign(propsUi, props);
        delete propsUi.config;
        delete propsUi.dispatch;
    }
    useEffect(() => {
        document.addEventListener('DOMContentLoaded', funciontEvent());

        return () => {
            document.removeEventListener(`DOMContentLoaded`, funciontEvent());
        }
        // eslint-disable-next-line
    }, [props.id]);

    const funciontEvent = () => {
        var textNeedCount = document.querySelectorAll(`#${props.id}`);
        M.CharacterCounter.init(textNeedCount);
    };

    useEffect(() => {
        if (!isNullOrEmpty(props.value) || !isNullOrEmpty(props.defaultValue)) {
            const documentClass = inputRef.labels[0];
            if (documentClass && documentClass.className && !documentClass.className.includes('active')) {
                inputRef.labels[0].className = `${inputRef.labels[0].className} active`;
            }

            if (documentClass && documentClass.className === '') {
                inputRef.labels[0].className = 'active';
            }
        }
        // eslint-disable-next-line
    }, [props.value, props.defaultValue]);

    const onEnableKeyboardConfigNumber = () => {
        if (props.config && props.config.enableKeyboard === "1" && props.type === "number" && navigator.userAgent === 'logisticspwa') {
            var er = /[^0-9.]/;
            er.lastIndex = 0;
            if (er.test(inputRef.value)) {
                inputRef.value = "";
            }
        }
    }

    const onChange = (event) => {
        onEnableKeyboardConfigNumber();
        validation(inputRef);
        if (props.onChange) {
            props.onChange(event);
        }
    };

    const onBlur = (event) => {
        onEnableKeyboardConfigNumber();
        validation(inputRef);
        if (props.onBlur) {
            props.onBlur(event);
        }
    };

    return (
        <>
            <textarea
                {...propsUi}
                ref={(el) => inputRef = el}
                onChange={onChange}
                onBlur={onBlur}
                className="materialize-textarea" />

            {
                !isNullOrEmpty(props.label) ? (
                    <label className={props.required ? 'required' : ''} htmlFor={props.id}>{props.label}</label>
                ) : null
            }
        </>

    );
};

const mapStateToProps = (state) => {
    return {
        config: state.configReducer.configUser,
    };
};

export default connect(mapStateToProps)(TextAreaUI);

